import React, { useContext, useEffect } from "react";
import { DataContext } from "../index";

function DailyMessage() {
  const msg = useContext(DataContext).msg;
  return <div className="daily-message">{msg}</div>;
}
export default DailyMessage;
